import { render, staticRenderFns } from "./PreviewInputFile.vue?vue&type=template&id=a4fab5a2&scoped=true&"
import script from "./PreviewInputFile.vue?vue&type=script&lang=ts&"
export * from "./PreviewInputFile.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewInputFile.vue?vue&type=style&index=0&id=a4fab5a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fab5a2",
  null
  
)

export default component.exports